export function isObject(value) {
	if (value === null) {
		return false;
	}

	return typeof value === 'object';
}

export function setDeep(object, path, value) {
	let ref = object;
	let keys = path.split('.');

	for (let i = 0; i < keys.length; i++) {
		let key = keys[i];

		if (i !== keys.length - 1) {
			ref = ref[key] || {};
		} else {
			ref = ref[key] = value;
		}
	}

	return object;
}

export function toClassName(property) {
	return property.replace(/([A-Z])/g, '-$1').toLowerCase();
}
